<template>
  <div class="partner-information" v-title data-title="城市合伙人">
    <div class="top">
      <!-- 标题 -->
      <div class="title">
        <span>城市合伙人</span>
        <span @click="$router.push('/withdraw-deposit')">去提现</span>
      </div>
      <p class="name">
        {{partent_msg.name}}
      </p>
      <!-- 等级 -->
      <div class="rank" @click="up_level">
        <p class="rule">
          升级规则
        </p>
        <!-- 等级展示 -->
        <div class="level-display">
          <p>
            <img src="../../assets/images/partner-img/partner-information/1.png" alt="">
            <span>当前等级/{{partent_msg.level_name}}合伙人</span>
          </p>
          <p>
            <img src="../../assets/images/partner-img/partner-information/11.png" alt="">
          </p>
        </div>
      </div>
    </div>
    <!-- 收益 -->
    <div class="earnings"> 
      <div class="earnings-top">
        <p @click="$router.push('/brokerage')">
          <span>
            分成（元）
          </span>
          <span>
            {{partent_msg.divide_into}}
          </span>
        </p>
        <p @click="$router.push('/brokerage/expenditure-income')">
          <span>
            返佣（元）
          </span>
          <span>
            {{partent_msg.rebate}}
          </span>
        </p>
        <p @click="$router.push('/sell-card')">
          <span>
            已销卡
          </span>
          <span>
            {{partent_msg.market_count}}张
          </span>
        </p>
      </div>
      <div class="line">
        <img src="../../assets/images/partner-img/partner-information/8.png" alt="">
      </div>
      <!-- 期权 积分 -->
      <div class="earnings-bottom" @click="options_msg">
        <dl>
          <dt><img src="../../assets/images/partner-img/partner-information/6.png" alt=""></dt>
          <dd>康养积分:{{partent_msg.score}}</dd>
        </dl>
        <dl>
          <dt><img src="../../assets/images/partner-img/partner-information/5.png" alt=""></dt>
          <dd>岗位期权:{{partent_msg.performance_vested_options}}股</dd>
        </dl>
        <dl>
          <dt><img src="../../assets/images/partner-img/partner-information/7.png" alt=""></dt>
          <dd>绩效期权:{{partent_msg.job_options}}股</dd>
        </dl>
      </div>
    </div>
    <!-- 我的团队 -->
    <div class="my-team" @click="$router.push('/my-team')">
      <div class="content">
        <img src="../../assets/images/partner-img/partner-information/18.png" alt="">
      </div>
      <p>
        查看我的团队
      </p>
    </div>
    <!-- 分享按钮 -->
    <div class="share-btn">
      <div class="btn">
        <img src="../../assets/images/partner-img/partner-information/12.png" alt="">
      </div>
    </div>
  </div>
</template>

<script>

import Vue from 'vue';
import { Toast } from 'vant';

Vue.use(Toast);


export default {
  data(){
    return{
      partent_msg : []
    }
  },
  created(){
    this.uid = JSON.parse(localStorage.getItem("uid"));
    // 合伙人中心
    this.$axios.post('http://members.kfm666666.net/api/order/index/getPartnerCenter',{
      uid : this.uid
    }).then((res) => {
      this.partent_msg = res.data
      // console.log(res.data)
    })
  },
  methods:{
    options_msg(){
      this.$router.push({
        path:'/returns-detailed',
        query:{
          id : 2
        }
      })
    },
    up_level(){
      Toast('达到要求自动升级')
    }
  }
}
</script>

<style lang="less" scoped>
  .partner-information{
    width: 7.5rem;
    display: flex;
    flex-direction: column;
    background: #f4f4f4;
    .top{
      width: 7.5rem;
      height: 4.65rem;
      background-image: url('../../assets/images/partner-img/partner-information/2.png');
      background-size: 100% 100%;
      overflow: hidden;
      // 标题
      .title{
        line-height: .3rem;
        margin-top: .75rem;
        span{
          &:first-child{
            font-size: 0.3rem;
            font-family: PingFang SC;
            font-weight: bold;
            color: #222222;
            float: left;
            margin-left: .21rem;
          }
          &:last-child{
            font-size: 0.24rem;
            font-family: PingFang SC;
            font-weight: 500;
            color: #FFFFFF;
            opacity: 0.8;
            float: right;
            margin-right: .21rem;
          }
        }
      }
      // 姓名
      .name{
        font-size: 0.36rem;
        font-family: PingFang SC;
        font-weight: 800;
        color: #1D1D1D;
        margin-top: 1rem;
        margin-left: .34rem;
        line-height: .36rem;
      }
      // 等级
      .rank{
        width: 7.1rem;
        height: 1.39rem;
        background-image: url('../../assets/images/partner-img/partner-information/9.png');
        background-size: 100% 100%;
        margin: 0 auto;
        margin-top: .29rem;
        display: flex;
        flex-direction: column;
        .rule{
          float: right;
          font-size: 0.22rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #171717;
          letter-spacing: .02rem;
          margin-top: .05rem;
          margin-right: .42rem;
          text-align: right;
        }
        .level-display{
          width: 100%;
          margin-top: .2rem;
          // display: flex;
          p{
            height: .7rem;
            &:first-child{
              float: left;
              display: flex;
              align-items: center;
              margin-left: .3rem;
              img{
                width: .43rem;
                height: .35rem;
              }
              span{
                font-size: 0.24rem;
                font-family: PingFang SC;
                font-weight: 500;
                color: #F1DA97;
                margin-left: .16rem;
              }
            }
            &:last-child{
              float: right;
              display: flex;
              align-items: center;
              margin-right: .21rem;
              img{
                width: 1.6rem;
                height: .6rem;
              }
            }
          }
        }
      }
      .clear{
        clear: both;
      }
    }
    // 收益
    .earnings{
      width: 7.1rem;
      height: 3rem;
      margin: 0 auto;
      border-radius: .1rem;
      background: #fff;
      margin-top: -.2rem;
      text-align: center;
      display: flex;
      flex-direction: column;
      // 分成 返佣
      .earnings-top{
        display: flex;
        p{
          width: 33%;
          text-align: center;
          margin-top: .61rem;
          span{
            display: block;
            &:first-child{
              font-size: 0.24rem;
              font-family: PingFang SC;
              font-weight: 500;
              color: #CFCFCF;
              line-height: .24rem;
            }
            &:last-child{
              font-size: 0.36rem;
              font-family: PingFang SC;
              font-weight: 800;
              color: #000000;
              line-height: .36rem;
              margin-top: .19rem;
            }
          }
        }
      }
      .line{
        width: 6.85rem;
        height: .01rem;
        margin: 0 auto;
        margin-top: .2rem;
        img{
          width: 6.85rem;
          height: .01rem;
        }
      }
      // 积分 期权
      .earnings-bottom{
        display: flex;
        margin-top: .66rem;
        dl{
          width: 33%;
          display: flex;
          text-align: center;
          margin-left: .3rem;
          &:first-child{
            dt{
              img{
                width: .23rem;
                height: .19rem;
              }
            }
          }
          &:nth-child(2){
            dt{
              img{
                width: .24rem;
                height: .22rem;
              }
            }
          }
          &:last-child{
            dt{
              img{
                width: .27rem;
                height: .22rem;
              }
            }
          }
          dt{
            margin-right: .1rem;
          }
          dd{
            font-size: 0.22rem;
            font-family: PingFang SC;
            font-weight: 400;
            color: #A2A2A2;
          }
        }
      }
    }
    // 我的团队
    .my-team{
      width: 7.1rem;
      height: 1.6rem;
      margin: 0 auto;     
      background: #fff;
      border-radius: .1rem;
      margin-top: .1rem;
      .content{
        width: .43rem;
        height: .43rem;
        margin: 0 auto;
        margin-top: .37rem;
        margin-bottom: .2rem;
        img{
          width: .43rem;
          height: .43rem;
        }
      }
      p{
        font-size: 0.24rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #212121;
        text-align: center;
      }
    }
    // 分享按钮
    .share-btn{
      width: 7.1rem;
      height: 4rem;
      background: #fff;
      border-radius: .1rem;
      margin: 0 auto;
      margin-top: .1rem;
      .btn{
        width: 2.53rem;
        height: 1.13rem;
        margin: 0 auto;
        margin-top: 1rem;
        img{
          width: 2.53rem;
          height: 1.13rem;
        } 
      }
    }
  }
</style>